module.exports = __webpack_public_path__ + "assets/img/userActive.0ea333a5.png";